'use client';

import Link from "next/link";

type Event = {
  id: number;
  eventName: string;
  eventHost?: string;
  eventTheme?: string;
  startDate: string; 
  endDate?: string;
  eventTime?: string;
  eventVenue?: string;
  eventImg?: string;
};

type EventListProps = {
  events: Event[];
};

const EventList = ({ events }: EventListProps) => {
  return (
    <div className="p-4 rounded-md mb-2">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {events.length === 0 ? (
          <p className="text-gray-500 text-sm col-span-full text-center">No upcoming events</p>
        ) : (
          events.map((event) => {
            const date = new Date(event.startDate);
            const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase();
            const day = date.getDate().toString().padStart(2, "0");

            return (
              <div key={event.id} className="bg-white rounded-lg items-center shadow-md overflow-hidden hover:shadow-lg transition cursor-default ">
                <div className="flex items-center justify-between p-4">
                  {/* Calendar Icon */}
                  <div className="bg-[#0f3055] rounded-md w-[100px] h-[135px] flex flex-col items-center justify-center p-[24px]">
                    <span className="text-[62px] font-bold tracking-tight text-white font-barlow -mb-4">{day}</span>
                    <span className="text-[50px]font-semibold tracking-tight transform scale-y-110 font-barlow text-[#f0e904]">{month}</span>
  
                  </div>

                  {/* Title and Text */}
                  <div className="ml-4 flex-1">
                    <h2 className="text-lg font-bold">{event.eventName}</h2>
                    {event.eventTheme && (
                      <p className="text-sm mt-1 leading-tight">{event.eventTheme}</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default EventList;